import { apiClient } from '@/shared/api/client'

export async function createAdminQuotation(payload) {
  const response = await apiClient.post('/admin/quotations', payload)

  return response.data
}

export async function getAdminQuotations(params = {}) {
  const response = await apiClient.get('/admin/quotations', {
    params,
  })

  return response.data
}

export async function getNextAdminQuoteNumber() {
  const response = await apiClient.get('/admin/quotations/next-number')

  return response.data
}

export async function getAdminQuotationById(id) {
  const response = await apiClient.get(`/admin/quotations/${id}`)

  return response.data
}

export async function getAdminQuotationByLeadId(leadId) {
  const response = await apiClient.get(`/admin/quotations/lead/${leadId}`)

  return response.data
}

export async function exportAdminQuotation(id) {
  const response = await apiClient.get(`/admin/quotations/${id}/export`, {
    responseType: 'blob',
  })

  return response.data
}

export async function getAdminQuotationStats(params = {}) {
  const response = await apiClient.get('/admin/quotations/stats', {
    params,
  })

  return response.data
}

export async function updateAdminQuotation(id, payload) {
  const response = await apiClient.patch(`/admin/quotations/${id}`, payload)

  return response.data
}

export async function deleteAdminQuotation(id) {
  const response = await apiClient.delete(`/admin/quotations/${id}`)

  return response.data
}

export async function getAdminQuotationEmailPreview(id) {
  const response = await apiClient.get(`/admin/quotations/${id}/email-preview`)

  return response.data
}

export async function sendAdminQuotation(id, payload) {
  const response = await apiClient.post(`/admin/quotations/${id}/send`, payload)

  return response.data
}
